import AnnotationCanvas from './AnnotationCanvas.vue';

export default AnnotationCanvas;